/**
 * @generated SignedSource<<ea3179d02ca20d249d544cf89acd75e8>>
 * @relayHash e3915d12272b627d2618559a173ee623
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 43b663d9649056a6c0dfa9fe437a3bf06ea1c47fa11d877c1439fabb16468bae

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceGraphQLContentMode = "COMPACT" | "DENSE" | "STANDARD" | "%future added value";
export type ConfluenceMutationContentStatus = "CURRENT" | "DRAFT" | "%future added value";
export type commitUpdateContentModeMutation$variables = {
  cloudId: string;
  contentId: string;
  contentMode: ConfluenceGraphQLContentMode;
  contentStatus: ConfluenceMutationContentStatus;
};
export type commitUpdateContentModeMutation$data = {
  readonly confluence_updateContentMode: {
    readonly contentId: string;
    readonly contentMode: ConfluenceGraphQLContentMode | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type commitUpdateContentModeMutation = {
  response: commitUpdateContentModeMutation$data;
  variables: commitUpdateContentModeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentMode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "contentMode",
            "variableName": "contentMode"
          },
          {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ConfluenceUpdateContentModePayload",
    "kind": "LinkedField",
    "name": "confluence_updateContentMode",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      },
      {
        "kind": "ScalarField",
        "name": "contentMode"
      },
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "commitUpdateContentModeMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "commitUpdateContentModeMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "e3915d12272b627d2618559a173ee623",
    "id": "43b663d9649056a6c0dfa9fe437a3bf06ea1c47fa11d877c1439fabb16468bae",
    "metadata": {},
    "name": "commitUpdateContentModeMutation",
    "operationKind": "mutation",
    "text": "mutation commitUpdateContentModeMutation($contentId:ID!,$contentMode:ConfluenceGraphQLContentMode!,$contentStatus:ConfluenceMutationContentStatus!,$cloudId:ID!){confluence_updateContentMode(cloudId:$cloudId,input:{contentId:$contentId,contentMode:$contentMode,contentStatus:$contentStatus}){contentId,contentMode,success,errors{message}}}"
  }
};
})();

(node as any).hash = "6aecb88002718fbacd480513a62a6ec2";

export default node;
